import { Helmet } from 'react-helmet';

interface SEOProps {
  prefix: string;
  path: string;
  description?: string;
}

const SEO = ({
  prefix,
  path,
  description = 'FarmTest Design Trial',
}: SEOProps) => {
  const seo = {
    description: description,
    url: `${window.location.origin}${path}`,
    title: `${prefix} | FarmTest`,
    image: '/og-image.jpeg',
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </Helmet>
  );
};

export default SEO;
